<p-dialog #viewDialog [(visible)]="showViewDialog" [style]="{width:'90%', height:'100%'}">
    <ng-template pTemplate="header">
        <div *ngIf="medicalBill" class="flex w-full justify-content-center gap-8">
            <div class="text-xl">Draft Id: {{medicalBill.id}}</div>
            <div class="text-xl">{{upperIdentifier}}</div>
            <div class="text-xl">{{lowerIdentifier}}</div>
            <div class="text-xl">{{billCategory?.categoryName}}</div>
            <div class="text-xl">Date Of Service: {{billDateOfService | date:'shortDate'}}</div>
        </div>
    </ng-template>
    <div class="flex grid" [style]="{height:'100%'}">
        <div class="flex col-5 max-h-full">
            <iframe [src]="billPDf" style="width:100%; height:100%;"></iframe>
        </div>
        <div *ngIf="medicalBill" class="flex col-7 flex-column max-h-full ">
            <div class="flex pb-3" style="height:25%;max-height:25%">
                <div *ngIf="!allowSave()" class="flex grid w-full">
                    <div class="col-6 max-h-full">
                        <p-card header="Processing Errors" [style]="{'max-height':'100%', 'overflow':'scroll'}">
                            <div *ngIf="medicalBill.allProcessingErrors.length > 0" class="flex flex-column overflow-scroll gap-2">
                                <div *ngFor="let issue of medicalBill.allProcessingErrors">
                                    <p-chip icon="pi pi-exclamation-triangle" [label]="issue.displayText"></p-chip>
                                </div>
                            </div> 
                            <div *ngIf="medicalBill.allProcessingErrors.length == 0" class="flex alig-items-center justify-content-center flex-column">
                                <div class="flex w-full justify-content-center"><i class="pi pi-check border-2 border-circle p-3 text-xxxl " style="background-color: green; color:white; fill:white"></i></div>
                                <div class="flex w-full justify-content-center">No Processing Errors!</div>
                            </div>
                        </p-card>
                    </div>
                    <div class="col-6 max-h-full">
                        <p-card [header]="'Form Errors ('+ formErrorCount +')'" [style]="{'max-height':'100%', 'overflow':'scroll'}" >
                            <div class="flex grid overflow-scroll">
                                <div *ngIf="!medicalBill.patient" class=" col-6 text-red-400"><p-tag>Patient Required</p-tag></div>
                                <div *ngIf="!medicalBill.patientAddress" class=" col-6  text-red-400"><p-tag>Patient Address Required</p-tag></div>
                                <div *ngIf="!medicalBill.phoneNumber" class=" col-6  text-red-400"><p-tag>Patient Phone Required</p-tag></div>
                                <div *ngIf="!medicalBill.patientAccountNumber" class=" col-6  text-red-400"><p-tag>Patient Account Required</p-tag></div>
                                <div *ngIf="!medicalBill.insuredName" class=" col-6  text-red-400"><p-tag>Insured Name Required</p-tag></div>
                                <div *ngIf="!medicalBill.insuredPhone" class=" col-6  text-red-400"><p-tag>Insured Phone Required</p-tag></div>
                                <div *ngIf="!medicalBill.insuredAddress || !medicalBill.insuredAddress.street1" class=" col-6  text-red-400"><p-tag>Insured Street Required</p-tag></div>
                                <div *ngIf="!medicalBill.insuredAddress || !medicalBill.insuredAddress.city" class=" col-6  text-red-400"><p-tag>Insured City Required</p-tag></div>
                                <div *ngIf="!medicalBill.insuredAddress || !medicalBill.insuredAddress.state" class=" col-6  text-red-400"><p-tag>Insured State Required</p-tag></div>
                                <div *ngIf="!medicalBill.insuredAddress || !medicalBill.insuredAddress.zipCode" class=" col-6  text-red-400"><p-tag>Insured Zip Code Required</p-tag></div>
                                <div *ngIf="!medicalBill.servicingProvider" class=" col-6  text-red-400"><p-tag>Servicing Provider Required</p-tag></div>
                                <div *ngIf="!medicalBill.billingProvider" class=" col-6  text-red-400"><p-tag>Billing Provider Required</p-tag></div>
                                <div *ngIf="!medicalBill.lines || medicalBill.lines.length == 0" class=" col-6  text-red-400"><p-tag>At Least One Billing Line Required</p-tag></div>
                                <div *ngIf="!allProceduresSet()" class=" col-6  text-red-400"><p-tag>All Lines Need a Procedure</p-tag></div>
                                <div *ngIf="!allServiceDatesSet()" class=" col-6  text-red-400"><p-tag>All Lines Need a Service Date</p-tag></div>
                                <div *ngIf="!allUnitsSet()" class=" col-6  text-red-400"><p-tag>All Lines Need Units</p-tag></div>
                                <div *ngIf="!allCostsSet()" class=" col-6  text-red-400"><p-tag>All Lines Need a Cost</p-tag></div>
                                <div *ngIf="!allDiagnosesSet()" class=" col-6  text-red-400"><p-tag>All Lines Need at least one Diagnosis</p-tag></div>
                                <div *ngIf="!selectedEncounter" class=" col-6  text-red-400"><p-tag>This Bill Must Reference an Encounter</p-tag></div>
                                

                            </div>
                        </p-card>
                    </div>
                </div>
                <div *ngIf="allowSave()" class="flex align-items-center justify-content-center flex-column w-full">
                    <div class="flex w-full justify-content-center"><i class="pi pi-check border-2 border-circle p-3 text-xxxl " style="background-color: green; color:white; fill:white"></i></div>
                    <div class="flex w-full justify-content-center">Bill Entry Complete</div>
                </div>
            </div>
            <form #billForm="ngForm" class="flex flex-column" style="height:70%; max-height:70%">
                <!-- Hidden inputs for duplicate detection -->
                 <input type="hidden" name="totalCost" [ngModel]="medicalBill.totalLinesCost"/>
                 <input type="hidden" name="serviceDate" [ngModel]="billDateOfService"/>

                <div class="flex overflow-scroll">
                    <div>
                    <p-fieldset legend="Patient Details" toggleable>
                        <div class="formgrid grid">
                            <div class="col-12">
                                <div *ngIf="!medicalBill.patient">
                                    <app-party-search #partySearch (partySelected)="patientSelected($event)" placeholder="Search Existing"></app-party-search>
                                </div>
                                <div *ngIf="medicalBill.patient" class="field w-full formgrid grid align-items-center">
                                    <div class="field col-5">
                                        <label for="patient">First Name</label>
                                        <input name="firstName" id="patient" type="text" pInputText [(ngModel)]="medicalBill.patient.firstName" disabled class="w-full"/>
                                    </div>
                                    <div class="field col-5">
                                        <label for="patient">Last Name</label>
                                        <input name="lastName" id="patient" type="text" pInputText [(ngModel)]="medicalBill.patient.lastName" disabled class="w-full"/>
                                    </div>
                                    <div class="col-2">
                                        <div class="flex justify-content-end align-items-end">
                                            <p-button icon="pi pi-trash" text (onClick)="clearPatient($event)"></p-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="medicalBill.patient" class="col-12 formgrid grid">
                                <div class="col-6 field" *ngIf="medicalBill.patient.addresses">
                                    <div class="flex align-items-end gap-2">
                                        <div class="flex-auto">
                                            <p-floatLabel>
                                                <p-dropdown name="patientAddress" id="patientAddress" appendTo="body" [options]="medicalBill.patient.addresses" [(ngModel)]="medicalBill.patientAddress" optionValue="location" styleClass="w-full" (onChange)="patientAddressChanged($event)">
                                                    <ng-template let-address pTemplate="item">
                                                        <div *ngIf="address">{{address.location.street1}} {{address.location.street2}} {{address.location.city}} {{address.location.state}} {{address.location.zipCode}}</div>
                                                    </ng-template>
                                                    <ng-template let-address pTemplate="selectedItem">
                                                        <div *ngIf="address" class="truncate-box">{{address.location.street1}} {{address.location.street2}} {{address.location.city}} {{address.location.state}} {{address.location.zipCode}}</div>
                                                    </ng-template>
                                                </p-dropdown>
                                                <label for="patientAddress">Address</label>

                                            </p-floatLabel>
                                        </div>
                                        <div>
                                            <p-button icon="pi pi-plus" (onClick)="openNewPatientAddressDialog()" tooltip="Add new patient address" tooltipPosition="top"></p-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 field"  *ngIf="medicalBill.patient.phones">
                                    <div class="flex align-items-end gap-2">
                                        <div class="flex-auto">
                                            <p-floatLabel>
                                                <p-dropdown  name="phoneNumber" id="phone" appendTo="body" [options]="medicalBill.patient.phones" [(ngModel)]="medicalBill.phoneNumber" optionLabel="e164PhoneNumber"  optionValue="phoneNumber" styleClass="w-full"></p-dropdown>
                                                <label for="phone">Phone Number</label>
                                            </p-floatLabel>
                                        </div>
                                        <div>
                                            <p-button icon="pi pi-plus" (onClick)="openNewPatientPhoneNumberDialog()" tooltip="Add new patient phone number" tooltipPosition="top"></p-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3 field mt-3" >
                                    <p-floatLabel>
                                        <p-dropdown  name="gender" id="gender" appendTo="body" [options]="genders" [(ngModel)]="medicalBill.gender"  styleClass="w-full" optionValue="value" optionLabel="display"></p-dropdown>    
                                        <label for="gender">Gender</label>
                                    </p-floatLabel>
                                </div>
                                <div class="col-6 field mt-3" >
                                    <p-floatLabel>
                                        <input name="patientAccountNumber" id="patientAccount" type="text" pInputText [(ngModel)]="medicalBill.patientAccountNumber" class="w-full"/>    
                                        <label for="patientAccount">Patient Account</label>
                                    </p-floatLabel>
                                </div>
                            </div>
                        </div>
                    </p-fieldset>
                    <p-fieldset legend="Insured Detail" toggleable>
                        <div class="formgrid grid">
                            <div class="col-6 field">
                                <p-floatLabel>
                                    <input name="insuredName" id="insuredName"  type="text" pInputText [(ngModel)]="medicalBill.insuredName" class="w-full"/>
                                    <label for="insuredName">Insured Name</label>

                                </p-floatLabel>
                            </div>
                            <div class="col-6 field">
                                <p-floatLabel>
                                    <input name="insuredPhone" id="insuredPhone" type="text" pInputText [(ngModel)]="medicalBill.insuredPhone" class="w-full"/>
                                    <label for="insuredPhone">Insured Phone</label>

                                </p-floatLabel>
                            </div>
                            <div class="col-12 field" *ngIf="medicalBill">
                                <div class="flex w-full">

                                    

                                    <div *ngIf="!medicalBill.insuredAddress" class="flex w-full align-items-center justify-content-center">
                                        <p-button label="Add New Address" icon="pi pi-plus" (onClick)="openNewInsuredAddressDialog()" tooltip="Add new insured address" tooltipPosition="top"></p-button>
                                    </div>
                                    <div *ngIf="medicalBill.insuredAddress" class="flex w-full align-items-center justify-content-center">
                                        <p-button label="Edit Address" icon="pi pi-pencil" (onClick)="openNewInsuredAddressDialog()" tooltip="Edit insured address" tooltipPosition="top"></p-button>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="medicalBill.insuredAddress" class="flex w-full flex-column">
                                <div class="w-full m-1 p-1">
                                    <div class="field">
                                        <p-floatLabel>
                                            <input name="insuredAddress1" id="street1" pInputText [disabled]="true" [(ngModel)]="medicalBill.insuredAddress.street1" class="w-full"/>
                                            <label for="street1">Street 1</label>
                                        </p-floatLabel>
                                    </div>
                                    <div class="field pt-2">
                                        <p-floatLabel>
                                            <input name="insuredAddress2" id="street2" pInputText [disabled]="true" [(ngModel)]="medicalBill.insuredAddress.street2" class="w-full" />
                                            <label for="street2">Street 2</label>
                                        </p-floatLabel>
                                    </div>
                                    <div class="flex grid">
                                        <div class="field col-6 pt-2">
                                            <p-floatLabel>
                                                <input name="insuredCity" id="city" pInputText [disabled]="true" [(ngModel)]="medicalBill.insuredAddress.city" class="w-full"/>
                                                <label for="city">City</label>
                                            </p-floatLabel>
                                        </div>
                                        <div class="field col-3 pt-2">
                                            <p-floatLabel>
                                                <input name="insuredState" id="state" pInputText [disabled]="true"  [(ngModel)]="medicalBill.insuredAddress.state" class="w-full"/>
                                                <label for="state">State</label>
                                            </p-floatLabel>
                                        </div>
                                        <div class="field col-3 pt-2">
                                            <p-floatLabel>
                                                <input name="insuredZipCode" id="zipCode" pInputText [disabled]="true"  [(ngModel)]="medicalBill.insuredAddress.zipCode" class="w-full"/>
                                                <label for="zipCode">Zip</label>
                                            </p-floatLabel>
                                        </div>
                                    </div>        
                                </div> 
                            </div>
                        </div>
                        

                    </p-fieldset>
                    <p-fieldset legend="Provider Information" toggleable>
                        <div class="formgrid grid">
                            <div class="col-12">
                                <div *ngIf="!medicalBill.servicingProvider" class="w-full">
                                    <app-facility-location-search  [(facility)]="medicalBill.servicingProvider"  (facilityChange)="servicingProviderChange($event)" placeholder="Select Servicing Provider"></app-facility-location-search>
                                </div>
                                <div *ngIf="medicalBill.servicingProvider" class="w-full">
                                    <p-card class="w-full" header="Servicing Provider">
                                        <div class="flex align-items-center w-full flex-row">
                                            <div *ngIf="medicalBill.servicingProvider" class="flex flex-column">
                                                <div>{{medicalBill.servicingProvider.facility.name}}</div>
                                                <div class="flex flex-column text-xs pt-2">
                                                    <div>{{medicalBill.servicingProvider.location.street1}}</div>
                                                    <div *ngIf="medicalBill.servicingProvider.location.street2">{{medicalBill.servicingProvider.location.street2}}</div>
                                                    <div>{{medicalBill.servicingProvider.location.city}}, {{medicalBill.servicingProvider.location.state}} {{medicalBill.servicingProvider.location.zipCode}}</div>
                                                </div>
                                            </div>
                                            <div class="flex flex-column">
                                                <p-button icon="pi pi-trash" text (onClick)="clearServicingProvider($event)"></p-button>
                                            </div>
                                        </div>
                                    </p-card>
                                </div>
                            </div>
                            <div class="col-12">
                                <div *ngIf="!medicalBill.billingProvider" class="w-full">
                                    <app-facility-location-search  [(facility)]="medicalBill.billingProvider"  (facilityChange)="billingProviderChange($event)" placeholder="Select Billing Provider" [includeBilling]="true"></app-facility-location-search>
                                </div>
                                <div *ngIf="medicalBill.billingProvider" class="w-full pt-2">
                                    <p-card class="w-full" header="Billing Provider">
                                        <div class="flex align-items-center w-full flex-row">
                                            <div *ngIf="medicalBill.billingProvider" class="flex flex-column">
                                                <div>{{medicalBill.billingProvider.facility.name}}</div>
                                                <div class="flex flex-column text-xs pt-2">
                                                    <div>{{medicalBill.billingProvider.location.street1}}</div>
                                                    <div *ngIf="medicalBill.billingProvider.location.street2">{{medicalBill.billingProvider.location.street2}}</div>
                                                    <div>{{medicalBill.billingProvider.location.city}}, {{medicalBill.billingProvider.location.state}} {{medicalBill.billingProvider.location.zipCode}}</div>
                                                </div>
                                            </div>
                                            <div class="flex flex-column">
                                                <p-button icon="pi pi-trash" text (onClick)="clearBillingProvider($event)"></p-button>
                                            </div>
                                        </div>
                                    </p-card>
                                </div>
                            </div>

                        </div>
                    </p-fieldset>
                    <p-fieldset legend="Line Details" toggleable>
                        <p-table styleClass="p-datatable-sm" [value]="medicalBill.lines" dataKey="procedure.code" > 
                            <ng-template pTemplate="caption">
                                <div class="flex align-items-center justify-content-between">
                                    Lines
                                    <p-button icon="pi pi-plus" text (onClick)="addLine($event)" />
                                </div>
                            </ng-template>
                            
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:15%">Procedure</th>
                                    <th style="width:15%">Modifiers</th>
                                    <th style="width:15%">Diagnosis</th>
                                    <th style="width:20%">Service Date</th>
                                    <th style="width:10%">Units</th>
                                    <th style="width:15%">Cost</th>
                                    <th style="width:10%"></th>
                                </tr>
                            </ng-template>

                            <ng-template  pTemplate="body" let-line let-editing="editing" let-rowIndex="rowIndex">
                                <tr>
                                    <td [pEditableColumn]="line.procedure" pEditableColumnField="procedure">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <app-procedure-selector [(procedure)]="line.procedure" (procedureSelected)="procedureChanged()"></app-procedure-selector>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <div class="flex p-1 align-items-center justify-content-center" style="height: 2.5rem">
                                                    <span [pTooltip]="procedureTooltip" style="cursor: pointer;" tooltipStyleClass="no-wrap-tooltip" [tooltipDisabled]="!line.procedure" >
                                                        <ng-template #procedureTooltip  appendTo="body">
                                                                <span><p-chip [label]="line.procedure?.code"/></span>
                                                                <span>&nbsp;{{line.procedure?.limitedDescription}}</span>
                                                        </ng-template>
                                                        <span *ngIf="line.procedure">{{line.procedure?.code}}</span>
                                                        <span *ngIf="!line.procedure">Enter Procedure...</span>
                                                    </span>
                                                </div>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td [pEditableColumn]="line.modifiers" pEditableColumnField="modifiers">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <app-modifier-selector [(modifiers)]="line.modifiers"></app-modifier-selector>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <div class="flex p-1 align-items-center justify-content-center" style="height: 2.5rem">
                                                    <span [pTooltip]="modifierTooltip" style="cursor: pointer;" tooltipStyleClass="no-wrap-tooltip" [tooltipDisabled]="(line.modifiers?.length || 0) == 0"> 
                                                        <ng-template #modifierTooltip  appendTo="body">
                                                            <div *ngFor="let modifier of line.modifiers"  class="flex mt-1 align-items-center" >
                                                                <span><p-chip [label]="modifier.code"/></span>
                                                                <span>&nbsp;{{modifier.limitedDescription}}</span>
                                                            </div>
                                                        </ng-template>
                                                        {{line.modifiers?.length || 0}} Modifier(s)
                                                    </span>
                                                </div>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td [pEditableColumn]="line.associatedDiagnosis" pEditableColumnField="associatedDiagnosis">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <app-diagnosis-selector [(diagnoses)]="line.associatedDiagnosis"></app-diagnosis-selector>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <div class="flex p-1 align-items-center justify-content-center" style="height: 2.5rem">
                                                    <span [pTooltip]="diagnosisTooltip" style="cursor: pointer;" tooltipStyleClass="no-wrap-tooltip" [tooltipDisabled]="(line.associatedDiagnosis?.length || 0) == 0"> 
                                                        <ng-template #diagnosisTooltip  appendTo="body">
                                                            <div *ngFor="let diagnosis of line.associatedDiagnosis" class="flex mt-1 align-items-center" >
                                                                <span><p-chip [label]="diagnosis.code"/></span>
                                                                <span>&nbsp;{{diagnosis.limitedDescription}}</span>
                                                            </div>
                                                        </ng-template>
                                                        {{line.associatedDiagnosis?.length || 0}} Diag Code(s)
                                                    </span>
                                                </div>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td [pEditableColumn]="line.dateOfService" pEditableColumnField="dateOfService">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <p-calendar [name]="'dateOfService'+rowIndex" appendTo="body" [(ngModel)]="line.dateOfService" class="w-full"></p-calendar>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <p-calendar [name]="'dateOfServiceOutput'+rowIndex" [(ngModel)]="line.dateOfService" styleClass="w-full"></p-calendar>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td [pEditableColumn]="line.units" pEditableColumnField="units">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <input [name]="'units'+rowIndex" id="units" pInputText [(ngModel)]="line.units" class="w-full"/>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <input [name]="'unitsOutput'+rowIndex" type="text" pInputText [ngModel]="line.units" placeholder="Units" class="w-full"/>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td [pEditableColumn]="line.cost" pEditableColumnField="cost">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <p-inputNumber [name]="'cost'+rowIndex" size="10" id="cost" pInputText [(ngModel)]="line.cost" mode="currency" currency="USD" locale="en-US" />
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                <p-inputNumber [name]="'costOutput'+rowIndex" size="10" type="text"  [ngModel]="line.cost" placeholder="Cost" mode="currency" currency="USD" locale="en-US"/>
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    
                                    <td>
                                        <p-button icon="pi pi-trash" text (onClick)="removeLine(line)"/>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </p-fieldset>
                    </div>
                </div>
                
                <div class="flex mt-4 grid" style="height:5%; max-height:5%;" >
                    <div class="flex col-12 align-items-center justify-content-center">
                        <p-tag *ngIf="isDuplicate" severity="danger" icon="pi pi-exclamation-triangle" value="Duplicate Bill Found"></p-tag>
                    </div>
                    <div class="flex col-4 align-items-end">
                        <p-floatLabel>
                            <p-dropdown name="encounter" id="encounter" [options]="encounters" optionLabel="displayName" [(ngModel)]="selectedEncounter">
                                <ng-template let-encounter pTemplate="item">
                                    <div>{{encounter.id}}</div>
                                    <div class="flex grid w-full">
                                        <div class="col-6">
                                            <div class="text-xs flex w-full align-items-center justify-content-center">Created</div>
                                            <div class="text-xs flex w-full align-items-center justify-content-center"><i class="pi pi-calendar-plus"></i></div>
                                            <div class="text-xs flex w-full align-items-center justify-content-center">{{encounter.encounterCreationDate | date:'shortDate'}}</div>
                                        </div>
                                        <div class="col-6 flex flex-column">
                                            <div class="text-xs flex w-full align-items-center justify-content-center">Appointment</div>
                                            <div class="text-xs flex w-full align-items-center justify-content-center"><i class="pi pi-calendar-clock"></i></div>
                                            <div *ngIf="encounter.getLatestAppointment()" class="text-xs flex w-full align-items-center justify-content-center">{{encounter.getLatestAppointment().appointmentDate | date:'shortDate'}}</div>
                                            <div *ngIf="!encounter.getLatestAppointment()" class="text-xs flex w-full align-items-center justify-content-center">N/A</div>

                                        </div>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                            <label for="encounter">Related Encounter</label>
                        </p-floatLabel>
                    </div>
                    <div class="col-4">
                        
                        <p-buttonGroup>
                            <p-button label="Save" icon="pi pi-check" (onClick)="saveButtonPressed($event)" [disabled]="!allowSave()"></p-button>
                            <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event)"></p-button>
                        </p-buttonGroup>

                    </div>
                    <div class="flex col-4 align-items-center">
                        <span class="p-2">Total Units: {{medicalBill.totalUnits}}</span>
                        <span class="p-2">Total Cost: {{medicalBill.totalLinesCost | currency}}</span>
                    </div>
                </div>
            </form>

        </div>
    </div>
</p-dialog>

<lib-address-editor #patientAddressEditor
  [(visible)]="showPatientAddressEditor"
  (save)="onPatientAddressSave($event)"
  (cancel)="onPatientAddressCancel()"
></lib-address-editor>

<lib-address-editor #insuredAddressEditor
  [(visible)]="showInsuredAddressEditor"
  [address]="medicalBill?.insuredAddress"
  (save)="onInsuredAddressSave($event)"
  (cancel)="onInsuredAddressCancel()"
></lib-address-editor>

<lib-phone-number-editor
  [(visible)]="showPatientPhoneNumberEditor"
  (save)="onPatientPhoneNumberSave($event)"
  (cancel)="onPatientPhoneNumberCancel()"
></lib-phone-number-editor>

<div class="grid">
    <div class="col-12" class="col-12 align-items-center">
        <div class="flex grid">
            <div class="flex col-3 align-items-center">
                <p-image *ngIf="thumbnailImage" [src]="thumbnailImage"
                    alt="Image" 
                    width="100%">
                </p-image>
            </div>
            <div class="flex grid col-9 align-items-center p-2">
                <div class="flex col-12 align-items-center ">
                    <div class="flex flex-column gap-1">
                    <div class="text-sm">{{upperIdentifier}}</div>
                    <div class="text-xs">{{lowerIdentifier}}</div>

                    <div *ngIf="medicalBill" class="text-xs">
                        Bill: {{medicalBill.id}} - {{billCategory?.categoryName}}
                        <p-tag *ngIf="isDuplicate" severity="danger" value="Duplicate!"/>

                    </div>
                    </div>

                </div>
                <div class="flex col-6 align-items-center text-sm gap-2">
                    <p-button *ngIf="(draftMedicalBill() != undefined)" size="small" icon="pi pi-pencil" [rounded]="true" [text]="true" [raised]="true" (onClick)="startEditing()"></p-button>
                    <p-button icon="pi pi-trash" [rounded]="true" [text]="true" [raised]="true" (onClick)="deleteBill()"></p-button>
                </div>
                <div class="flex col-3 align-items-center">
                    <span *ngIf="(draftMedicalBill() == undefined)"><p-button size="small" [disabled]="isProcessing$ | async" [icon]="!(isProcessing$ | async) ? 'pi pi-refresh' : 'pi pi-spin pi-spinner'" [rounded]="true" [text]="true" [raised]="true" (onClick)="refreshButtonPressed()"> </p-button></span>
                    <span *ngIf="medicalBill != undefined">
                        <span *ngIf="allowSave()"><i class="pi pi-check p-2 border-2 border-circle" style="background-color: green; color:white; fill:white"></i></span>
                        <span *ngIf="!allowSave() && formErrorCount > 0 && medicalBill.allProcessingErrors.length == 0"><i class="pi pi-exclamation-triangle text-4xl" style="color:orange; fill:orange" pBadge [value]="formErrorCount"></i></span>
                        <span *ngIf="!allowSave() && medicalBill.allProcessingErrors.length > 0"><i class="pi pi-exclamation-circle text-4xl" style="color:red; fill:red" pBadge [value]="medicalBill.allProcessingErrors.length"></i></span>

                    </span>
                </div>
                <div class="flex col-3 justify-content-center text-xs">
                    <span>{{submissionStatus$ | async}}</span>
                </div>
            </div>
        </div>
        
    </div>
</div>